import ApiService from "@/core/services/api.service";
export const FIND_CUSTOMER_CAMPAIGN_POINT = "findCustomerCampaignPoint";

export default {
  state: {
    path: "customer_campaign_point"
  },
  getters: {},
  actions: {
    [FIND_CUSTOMER_CAMPAIGN_POINT](context, payload) {
      ApiService.setHeader();
      return ApiService.getParams(
        `${context.state.path}/${payload.campaign_id}`, {
          params: payload
        }
      );
    }
  },
  mutations: {}
};